// src/components/About.js
import React, { useEffect, useContext, useState } from "react";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import ConfirmationModal from "../modals/ConfirmationModal";
import config from "../../config/config";

const MyTransactions = () => {
  const [showModal, setShowModal] = useState(false);
  const [msgTitle, setMsgTitle] = useState("");
  const [message, setMessage] = useState("");
  const [icon, setIcon] = useState("");
  const [theme, setTheme] = useState("");

  const { isAuthenticated } = useContext(AppContext);

  const [transactionData, setTransactionData] = useState([]);
  // Fetch Bearer token (Assuming it's stored in localStorage)
  const token = config.getAuthToken();

  const fetchTransactionData = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/getMyTransactions`,
        { userId: 9 },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status) {
        setTransactionData(response.data.data); // Assuming 'data' contains the reviews array
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);
      if (error.response) {
        if (error.response.status === 404) {
          setShowModal(true);
          setMsgTitle("No transactions found for this user");
          setMessage();
          setIcon("fa fa-info-circle");
          setTheme("gold");
        } else {
          setShowModal(true);
          setMsgTitle("Failed to fetch data. Please try again.");
          setMessage();
          setIcon("fa fa-times-circle-o");
          setTheme("red");
        }
      } else {
        // error.response is undefined - network error, timeout, CORS, etc
        setShowModal(true);
        setMsgTitle("Something went wrong. Please check your connection.");
        setMessage();
        setIcon("fa fa-times-circle-o");
        setTheme("red");
      }
      // alert('Failed to fetch data. Please try again.');
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchTransactionData();
    }
  }, [isAuthenticated]);

  return (
    <>
      <div className="nofltrbx">
        <div className="title-header breadcrumb">
          <div className="profile-path">
            <span>My Transactions</span>
          </div>
        </div>
      </div>

      {showModal && (
        <ConfirmationModal
          onClose={() => setShowModal(false)}
          title={msgTitle}
          message={message}
          icon={icon}
          theme={theme}
        />
      )}
    </>
  );
};

export default MyTransactions;
